import { useMutation, useQueryClient } from '@tanstack/react-query';

import { redFlagsService } from '../services';
import type { RaiseRedFlagInput } from '../types';

import { redFlagsKeys } from './useRedFlags';

export function useCreateRedFlag(clientId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: RaiseRedFlagInput) => redFlagsService.createFlag(clientId, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: redFlagsKeys.lists() });
      void qc.invalidateQueries({ queryKey: redFlagsKeys.operation('client', { clientId }) });
      void qc.invalidateQueries({ queryKey: redFlagsKeys.operation('count-open') });
    },
  });
}
